import type { PayloadAction } from '@reduxjs/toolkit';
import { createAction, createSlice } from '@reduxjs/toolkit';
import type { AxiosResponse } from 'axios';

import type { Network, ResponseError } from '../../types';
import type { ResetModalData } from './LinkSentModal';
import type { LoginFormDataType } from './types';

export const initialState = {
    loading: false,
    formData: {
        email: '',
        password: '',
        joinProject: '',
        lang: '',
    },
    error: <ResponseError | null>null,
    forgetModal: {
        loading: false,
        error: <ResponseError | null>null,
    },
};

const loginSlice = createSlice({
    name: 'login',
    initialState,
    reducers: {
        setLoading: (state, { payload }: PayloadAction<boolean>) => {
            state.loading = payload;
        },
        setError: (state, { payload }: PayloadAction<ResponseError | null>) => {
            state.error = payload;
        },
        updateFormData: (state, { payload }: PayloadAction<LoginFormDataType>) => {
            state.formData = {
                ...state.formData,
                ...payload,
            };
        },
        setLoadingForgetModal: (state, { payload }: PayloadAction<boolean>) => {
            state.forgetModal.loading = payload;
        },
        setErrorForgetModal: (state, { payload }: PayloadAction<ResponseError | null>) => {
            state.forgetModal.error = payload;
        },
    },
});

const login = createAction('auth/login');
const networkLogin = createAction('auth/networkLogin', (network: Network, from?: string) => ({
    payload: { network, from },
}));
const forgetPasswordRequest = createAction(
    'auth/forgetPasswordRequest',
    (email: string, callback: (response: AxiosResponse<ResetModalData>) => void) => ({ payload: { email, callback } }),
);

export default loginSlice.reducer;

export const loginActions = {
    ...loginSlice.actions,
    login,
    networkLogin,
    forgetPasswordRequest,
};
